import { reactive, computed } from 'vue';
import Report from './Report';

const state = reactive({
  currentReport: Report
})

export default () => ({
  currentReport: computed(() => state.currentReport)
})